import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import { enhancedConnect } from "../../../utils";
import styles from "./styles.pcss";
import { toPx } from "../../utils/side";
var cn = classNames.bind(styles);
var _CardContainer = function _CardContainer(_ref) {
  var minHeight = _ref.minHeight,
    _ref$vAlign = _ref.vAlign,
    vAlign = _ref$vAlign === void 0 ? 'justify' : _ref$vAlign,
    children = _ref.children,
    _ref$hovered = _ref.hovered,
    hovered = _ref$hovered === void 0 ? false : _ref$hovered,
    theme = _ref.theme,
    href = _ref.href,
    isBlankUrlTarget = _ref.isBlankUrlTarget,
    className = _ref.className,
    minWidth = _ref.minWidth,
    animationType = _ref.animationType;
  var Tag = href ? 'a' : 'div';
  return /*#__PURE__*/React.createElement(Tag, {
    className: cn('container', "vAlign--".concat(vAlign), hovered && 'hovered', "animation--".concat(animationType), cnComponentsTheme(theme), className),
    href: href,
    style: {
      minHeight: toPx(minHeight),
      minWidth: toPx(minWidth)
    },
    target: isBlankUrlTarget ? '_blank' : '_self',
    "data-t-id": "Card-CardContainer"
  }, children);
};
export var CardContainer = compose(enhancedConnect({
  minHeight: PropTypes.number,
  minWidth: PropTypes.number,
  vAlign: PropTypes.oneOf(['justify', 'middle', 'top', 'bottom']),
  children: PropTypes.node,
  href: PropTypes.string,
  isBlankUrlTarget: PropTypes.bool,
  hovered: PropTypes.bool,
  theme: PropTypes.oneOf([undefined, 'light', 'dark']),
  animationType: PropTypes.oneOf(['hover', undefined])
}), withAutoMetric.Element('Card'))(_CardContainer);